/**
 * 查看培训记录
 * @author xyguo
 * @date 2021-3-16
 */
 import React from 'react';
 import { connect } from 'dva';
 import { framework_tool, component_tool, utils_tool } from '@/tool';
 let { WizModal, WizComponent, WizForm, WizCheckbox, WizRow, WizCol,WizSpin,WizButton,WizInputNumber } = component_tool;
 let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
 let { $$, checkStrLength } = utils_tool;
 import '../../../../styles/containers/train/path/requirement/style.less'
 class LookPositionAuthState extends WizContainer {
 
   componentName = 'LookPositionAuthState';
 
   constructor(props) {
    super(props)
    let { record } = props
    this.state = {
        record,
        positionAuthState : record.positionAuthState,
        positionAuthScore : record.positionAuthScore,
        timestamp: new Date().getTime(),
    }
}
 
   _componentDidMount() {
     
   }

   _recordColumns = (record = {}) => {
    return [
        {
            title: '认证人员',
            name: 'name',
            formItem: {
                type: 'custom',
                render: () => {
                    return <div>{record.positionName}-{record.fullName}</div>
                }
            }
        },
        {
          title: '认证分数',
          name: 'positionAuthScore',
          formItem: {
            type: 'custom',
            render: (record, form) => {
              const { getFieldDecorator } = form
              return (
                <WizRow>
                  <WizCol span={12}>
                    {
                      getFieldDecorator('positionAuthScore', {
                        rules: [{ required: true, message: '请输入分数' }],
                        initialValue: record['positionAuthScore']
                      })(
                        <WizInputNumber min={0} max={100} size='middle' precision={1} disabled={true}
                        onChange={(value) => {
                          this.setState({ 
                            positionAuthScore: value 
                          })
                        }
                        }
                        />
                      )
                    }
                  </WizCol>
                </WizRow>
              )
            }
        }
      },
        {
            title: '认证结果',
            name: 'positionAuthState',
            dict: [
                { code: 0, codeName: '合格' },
                { code: 1, codeName: '不合格' }
            ],
            formItem: {
                type: 'radio',
                rules: [
                  {
                    required: true,
                    message: '请选择认证结果'
                  },
                ],
                onChange: (form, value, e) => this.setState({ positionAuthState: value }),
                disabled : true
            }
        },
        
    ]
}
 
   propsAndStateOnChange = {
    
   };
 
   render() {
     const {requirementRecordLoading } = this.props;
     let {record, timestamp } = this.state
     let columns = this._recordColumns(record)
    // let onSubmit = this._onSave.bind(this);
     let formProps = {
      ref: 'formRef',
      key: timestamp,
      columns,
      record: record || { status: 0 },
     // preview: false,
      footer: null,
      formItemLayout: {
          labelCol: { span: 5 },
          wrapperCol: { span: 16 }
      }
  }
     return <WizForm {...formProps} />
   }
 }
 
 const mapStateToProps = (state, ownProps) => {
   return {
  
   };
 };
 
 export default connect(mapStateToProps)(LookPositionAuthState);
 
 